<template>
  <div class="content">
    <h2 class="pl-3">{{ father }} | Usuarios</h2>
    <v-dialog v-model="dialog" width="600px">
      <v-card style="overflow:hidden;">
        <v-card-title class="grey lighten-4 py-4 title">{{ tituloDialogo }}</v-card-title>
        <usuario
          :idUsuario="indiceEdicion"
          :usuario="usuarioEditar"
          :reset="dialog"
          @editarCrearUsuario:mostrarOcultarDialog="mostrarOcultarDialog"
          @editarCrearUsuario:listarUsuarios="listarUsuarios"
        />
      </v-card>
    </v-dialog>
    <template>
      <v-card class="pa-3 ma-3">
        <v-layout row wrap>
          <v-flex xs3 offset-xs9>
            <v-btn
              color="success"
              @click="editarCrearUsuario('Agregar Nuevo Usuario', '-1')"
            >Añadir Nuevo Usuario</v-btn>
          </v-flex>
        </v-layout>
        <v-card-title>
          <v-row justify="center">
            <v-col cols="6">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                solo
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="usuarios"
          :search="search"
          ref="lista_usuarios"
          :loading="loadingDataUsuarios"
          loading-text="Cargando Datos... Porfavor espere"
        >
          <template v-slot:item.estado="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  :class="[item.estado != '1'? 'redColor' : 'greenColor']"
                >{{(item.estado!=1)? 'mdi-emoticon-sad-outline': 'mdi-emoticon-excited-outline'}}</v-icon>
              </template>
              <span>{{item.estado != '1'? 'Deshabilitado' : 'Habilitado'}}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.edit="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="editarCrearUsuario('Editar Usuario', item.idusuario, item)"
                >mdi-pencil</v-icon>
              </template>
              <span>Editar Usuario</span>
            </v-tooltip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="cambiarEstadoUsuario(item)"
                  :class="[item.estado != '1'? 'greenColor' : 'redColor']"
                >{{(item.estado!=1)? 'mdi-check-bold': 'mdi-close-thick'}}</v-icon>
              </template>
              <span>{{item.estado != '1'? 'Habilitar Usuario' : 'Deshabilitar Usuario'}}</span>
            </v-tooltip>
          </template>

          <template v-slot:no-data>
            <div class="text-xs-center">No hay Personas Cargadas</div>
          </template>
        </v-data-table>
        <v-layout row wrap>
          <v-flex xs3 offset-xs9>
            <v-btn
              color="success"
              @click="editarCrearUsuario('Agregar Nuevo Usuario', '-1')"
            >Añadir Nuevo Usuario</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </template>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import usuario from "./editarCrearUsuario";

export default {
  //data: () => ({
  data() {
    return {
      dialog: false,
      loadingDataUsuarios: true,
      indiceEdicion: "",
      limpiarFormulario: true,
      usuarioEditar: "",
      tituloDialogo: "",
      search: "",
      pagination: {
        sortBy: "name"
      },
      headers: [
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "nombre"
        },
        {
          text: "Apellido",
          sortable: true,
          value: "apellido"
        },
        { text: "Dni", sortable: false, class: "", value: "dni" },
        { text: "Perfil", sortable: false, value: "categoria" },
        { text: "", value: "estado", sortable: false, width: 50 },
        { text: "", value: "edit", sortable: false, width: 50 },
        { text: "", value: "actions", sortable: false, width: 50 }
      ],
      usuarios: []
    };
  },
  props: ["father"],
  components: {
    usuario
  },
  mounted: function() {
    this.listarUsuarios();
  },
  computed: {},
  watch: {},
  methods: {
    listarUsuarios() {
      this.loadingDataUsuarios = true;
      let resultado = API.enviar("get", "obtenerUsuarios", "");

      resultado
        .then(result => {
          if (result.data.msj == "ok") this.usuarios = result.data.result;
        })
        .catch(error => {
          console.log(
            "listarUsuarios | methods | listarUsuarios |  catch: -> ",
            error
          );
        })
        .finally(() => {
          this.loadingDataUsuarios = false;
        });
    },
    cambiarEstadoUsuario: function(elem) {
      let param = "idUsuario=" + elem.idusuario + "&estado=" + elem.estado;
      let resultadoEditar = API.enviar("get", "cambiarEstadoUsuario", param);

      resultadoEditar
        .then(() => {
          let resultadoObtener = API.enviar("get", "obtenerUsuarios", "");
          resultadoObtener
            .then(() => {
              this.listarUsuarios();
            })
            .catch(error => {
              console.log("Catch 2 cambiarEstadoUsuario !!!", error);
            });
        })
        .catch(error => {
          console.log("Catch 1 cambiarEstadoUsuario !!!", error);
        });
    },
    editarCrearUsuario: function(titulo, idUsuario, usuario) {
      //if (event) event.stopPropagation();
      /*if (idUsuario != -1) {
      }*/

      this.tituloDialogo = titulo;
      this.dialog = true;
      this.indiceEdicion = idUsuario;
      this.usuarioEditar = usuario;
    } /*
    editItem(item) {
      console.log(item);
      this.editedIndex = this.usuarios.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },*/,
    mostrarOcultarDialog: function() {
      this.dialog = !this.dialog;
    }
  }
};
</script>

<style scoped>
.content {
  width: 100%;
}

h2 {
  text-align: left;
  margin-bottom: 10px;
}

.v-data-table,
td {
  text-transform: capitalize !important;
}

.greenColor {
  color: green;
}
.redColor {
  color: red;
}
.v-icon {
  cursor: pointer;
}
</style>